module.exports = __webpack_public_path__ + "static/media/invoice.362508c7.svg";